import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { makeApiCall } from '../../services/httpService';
import { BASE_URL } from '../../config';
import toast from 'react-hot-toast';
import DContext from '../../context/DContext';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ContentLoader from '../loader/ContentLoader';



const AddFlight = () => {
  const location = useLocation();


  const { authState, authDispatch, logout } = useContext(DContext);
  const { user } = authState;

  const [loading, setLoading] = useState(false);
  const [airlinesDropdown, setAirlinesDropdown] = useState([]);
  const initialFlightDetail = {
    airlineId: "",
    flightName: "",
    flightCode: "",
    flightNumber: "",
    depAirportId: "",
    depAirportCode: "",
    depCityName: "",
    depCountry: "",
    arrAirportId: "",
    arrAirportCode: "",
    arrCityName: "",
    arrCountry: "",
    depTime: "",
    arrTime: "",
    depTerminal: "",
    arrTerminal: ""
  };
  const [flightDetail, setFlightDetail] = useState(initialFlightDetail);


  useEffect(() => {
    loadAirlines();
  }, []);



  const showSwal = (title, text, icon) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon // 'success' | 'error' | 'warning' | 'info' | 'question'
    })
  }

  const loadAirlines = async () => {
    try {
      let apiUrl = `${BASE_URL}/api/utils/airlines?&page=1&limit=500`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        setAirlinesDropdown(apiRes?.resData);
        return apiRes.resData;
      } else {
        toast.error(apiRes.message);
        //showSwal("Error",apiRes.message,"error")

      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    }
  }

  const loadAirports = async (searchq = null) => {
    try {
      let apiUrl = `${BASE_URL}/api/utils/airport?searchq=${searchq}&page=1&limit=20`;
      let apiRes = await makeApiCall("GET", null, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        //toast.success(apiRes.message);
        return apiRes.resData;
      } else {
        toast.error(apiRes.message);
      }
    } catch (err) {
      console.log("Fatal Error", err);
      //toast.error("Something Went Wrong...");
      showSwal("Error", "Something went wrong...", "error")
    }
  }


  const handleSelectChange = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    setFlightDetail({
      ...flightDetail,
      flightName: selectedOption?.airline_name,
      airlineId: selectedOption?.value,
      flightCode: selectedOption?.airline_code
    })
  };

  const handleSelectChangeDepAirport = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    setFlightDetail({
      ...flightDetail,
      depAirportId: selectedOption?.value,
      depAirportCode: selectedOption?.airport_code,
      depCityName: selectedOption?.city_name,
      depCountry: selectedOption?.country_name
    })
  };


  const handleSelectChangeArrAirport = (selectedOption) => {
    console.log("Selected option:", selectedOption);
    setFlightDetail({
      ...flightDetail,
      arrAirportId: selectedOption?.value,
      arrAirportCode: selectedOption?.airport_code,
      arrCityName: selectedOption?.city_name,
      arrCountry: selectedOption?.country_name
    })
  };


  const handleChange = (e) => {
    setFlightDetail({ ...flightDetail, [e.target.name]: e.target.value });
  }

  const handleTimeChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // remove non-digits

    if (value.length > 2) {
      value = value.slice(0, 2) + ":" + value.slice(2, 4); // insert ":"
    }

    if (value.length > 5) {
      value = value.slice(0, 5); // max length 5 (HH:MM)
    }

    setFlightDetail({ ...flightDetail, [e.target.name]: value });
  };

  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      let bodyPayload = {};
      e.preventDefault();

      bodyPayload.form_data = flightDetail;
      console.log("final form data", bodyPayload);
      let apiUrl = `${BASE_URL}/api/flights`;
      let apiRes = await makeApiCall("POST", bodyPayload, apiUrl);
      console.log(apiRes);
      if (apiRes?.statusCode == 200) {
        showSwal("Success", apiRes.message, "success");
        setFlightDetail(initialFlightDetail);
      } else {
        console.log(apiRes?.response?.data?.message)
        if (apiRes?.response?.data?.message) {
          showSwal("Error", apiRes?.response?.data?.message, "error")
        } else {
          toast.error(apiRes.message);
        }
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error")
    } finally {
      setLoading(false);
    }
  }


  // Debounce the actual fetch call
  // const debouncedLoadAirports = useCallback(
  //   debounce((value) => {
  //     loadAirports(value);
  //   }, 300),
  //   []
  // );
  if (loading) return (<ContentLoader loaderType="circleSpin" />)
  return (
    <>
      <section className="section dashboard">
        <div className="row">
          <div className="col-lg-12">
            <div className="card border-0 shadow-sm" style={{ borderRadius: "16px" }}>
              <div className="card-body p-3">

                {/* Header */}
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <div style={{
                      width: "32px", height: "32px", borderRadius: "8px",
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      display: "flex", alignItems: "center", justifyContent: "center"
                    }}>
                      <i className="bi bi-airplane-fill text-white" style={{ fontSize: "14px" }}></i>
                    </div>
                    <h6 className="mb-0 fw-bold" style={{ color: "#2d3748" }}>New Flight Detail</h6>
                  </div>
                  <Link
                    to="/flight/list"
                    className="btn btn-sm d-flex align-items-center gap-1 px-3"
                    style={{
                      background: "white", border: "1.5px solid #667eea", color: "#667eea",
                      borderRadius: "20px", fontSize: "13px"
                    }}
                  >
                    <i className="bi bi-arrow-left"></i> Back
                  </Link>
                </div>

                <form onSubmit={handleSubmit}>

                  {/* Row 1: Airline Info */}
                  <div className="p-2 mb-2 rounded-3" style={{ background: "#f8f9fe", border: "1px solid #e9ecef" }}>
                    <div className="d-flex align-items-center gap-1 mb-2">
                      <i className="bi bi-building" style={{ color: "#667eea", fontSize: "13px" }}></i>
                      <span style={{ fontSize: "12px", fontWeight: "600", color: "#667eea", textTransform: "uppercase", letterSpacing: "0.5px" }}>Airline</span>
                    </div>
                    <div className="row g-2 align-items-center">
                      <div className="col-md-4">
                        <Select
                          options={airlinesDropdown}
                          onMenuOpen={() => console.log('Menu opened (click detected)')}
                          onChange={handleSelectChange}
                          placeholder="Select airline..."
                          isSearchable={true}
                          isClearable={true}
                          styles={{
                            control: (base) => ({
                              ...base, borderRadius: "8px", border: "1.5px solid #e9ecef",
                              background: "white", minHeight: "38px", fontSize: "13px", boxShadow: "none",
                              "&:hover": { borderColor: "#667eea" }
                            }),
                            placeholder: (base) => ({ ...base, color: "#adb5bd", fontSize: "13px" }),
                          }}
                        />
                      </div>
                      <div className="col-md-1 text-center">
                        {flightDetail?.flightCode && (
                          <img
                            src={`https://images.kiwi.com/airlines/32/${flightDetail?.flightCode}.png`}
                            style={{ width: "32px", height: "32px", objectFit: "contain" }}
                            alt="airline logo"
                          />
                        )}
                      </div>
                      <div className="col-md-3">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text" style={{ background: "#f0f0ff", border: "1.5px solid #e9ecef", borderRight: "none", borderRadius: "8px 0 0 8px", fontSize: "13px" }}>
                            <i className="bi bi-tag" style={{ color: "#667eea" }}></i>
                          </span>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Flight Code"
                            name="flightCode"
                            value={flightDetail?.flightCode || ""}
                            readOnly
                            style={{ textTransform: "uppercase", border: "1.5px solid #e9ecef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f0f0f0", fontSize: "13px" }}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="input-group input-group-sm">
                          <span className="input-group-text" style={{ background: "#f0f0ff", border: "1.5px solid #e9ecef", borderRight: "none", borderRadius: "8px 0 0 8px", fontSize: "13px" }}>
                            <i className="bi bi-hash" style={{ color: "#667eea" }}></i>
                          </span>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Flight Number"
                            name="flightNumber"
                            value={flightDetail?.flightNumber || ""}
                            onChange={handleChange}
                            style={{ border: "1.5px solid #e9ecef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Row 2: Departure + Arrival side by side */}
                  <div className="row g-2 mb-2">

                    {/* Departure */}
                    <div className="col-md-6">
                      <div className="p-2 h-100 rounded-3" style={{ background: "#f0fff4", border: "1px solid #c6f6d5" }}>
                        <div className="d-flex align-items-center gap-1 mb-2">
                          <i className="bi bi-arrow-up-circle-fill" style={{ color: "#38a169", fontSize: "13px" }}></i>
                          <span style={{ fontSize: "12px", fontWeight: "600", color: "#38a169", textTransform: "uppercase", letterSpacing: "0.5px" }}>Departure</span>
                        </div>
                        <div className="row g-2">
                          <div className="col-12">
                            <AsyncSelect
                              cacheOptions
                              name="dep_airport_dropdown"
                              placeholder="Search departure airport..."
                              loadOptions={loadAirports}
                              onChange={handleSelectChangeDepAirport}
                              defaultOptions={false}
                              isClearable
                              isSearchable
                              styles={{
                                control: (base) => ({
                                  ...base, borderRadius: "8px", border: "1.5px solid #c6f6d5",
                                  background: "white", minHeight: "38px", fontSize: "13px", boxShadow: "none",
                                  "&:hover": { borderColor: "#38a169" }
                                }),
                                placeholder: (base) => ({ ...base, color: "#adb5bd", fontSize: "13px" }),
                              }}
                            />
                          </div>
                          <div className="col-4">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="IATA Code"
                              name="depAirportCode"
                              value={flightDetail?.depAirportCode || ""}
                              readOnly
                              style={{ textTransform: "uppercase", borderRadius: "8px", border: "1.5px solid #c6f6d5", background: "#f0f0f0", fontSize: "13px" }}
                            />
                          </div>
                          <div className="col-4">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="City"
                              name="depCityName"
                              value={flightDetail?.depCityName || ""}
                              onChange={handleChange}
                              style={{ borderRadius: "8px", border: "1.5px solid #c6f6d5", background: "white", fontSize: "13px" }}
                            />
                          </div>
                          <div className="col-4">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Country"
                              name="depCountry"
                              value={flightDetail?.depCountry || ""}
                              readOnly
                              style={{ borderRadius: "8px", border: "1.5px solid #c6f6d5", background: "#f0f0f0", fontSize: "13px" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Arrival */}
                    <div className="col-md-6">
                      <div className="p-2 h-100 rounded-3" style={{ background: "#fffbf0", border: "1px solid #fbd38d" }}>
                        <div className="d-flex align-items-center gap-1 mb-2">
                          <i className="bi bi-arrow-down-circle-fill" style={{ color: "#d69e2e", fontSize: "13px" }}></i>
                          <span style={{ fontSize: "12px", fontWeight: "600", color: "#d69e2e", textTransform: "uppercase", letterSpacing: "0.5px" }}>Arrival</span>
                        </div>
                        <div className="row g-2">
                          <div className="col-12">
                            <AsyncSelect
                              cacheOptions
                              name="arr_airport_dropdown"
                              placeholder="Search arrival airport..."
                              loadOptions={loadAirports}
                              onChange={handleSelectChangeArrAirport}
                              defaultOptions={false}
                              isClearable
                              isSearchable
                              styles={{
                                control: (base) => ({
                                  ...base, borderRadius: "8px", border: "1.5px solid #fbd38d",
                                  background: "white", minHeight: "38px", fontSize: "13px", boxShadow: "none",
                                  "&:hover": { borderColor: "#d69e2e" }
                                }),
                                placeholder: (base) => ({ ...base, color: "#adb5bd", fontSize: "13px" }),
                              }}
                            />
                          </div>
                          <div className="col-4">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="IATA Code"
                              name="arrAirportcode"
                              value={flightDetail?.arrAirportCode || ""}
                              readOnly
                              style={{ textTransform: "uppercase", borderRadius: "8px", border: "1.5px solid #fbd38d", background: "#f0f0f0", fontSize: "13px" }}
                            />
                          </div>
                          <div className="col-4">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="City"
                              name="arrCityName"
                              value={flightDetail?.arrCityName || ""}
                              onChange={handleChange}
                              style={{ borderRadius: "8px", border: "1.5px solid #fbd38d", background: "white", fontSize: "13px" }}
                            />
                          </div>
                          <div className="col-4">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder="Country"
                              name="arrCountry"
                              value={flightDetail?.arrCountry || ""}
                              readOnly
                              style={{ borderRadius: "8px", border: "1.5px solid #fbd38d", background: "#f0f0f0", fontSize: "13px" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Row 3: Schedule & Terminals + Submit */}
                  <div className="p-2 rounded-3" style={{ background: "#f8f0ff", border: "1px solid #d6bcfa" }}>

                    {/* Section label */}
                    <div className="d-flex align-items-center gap-1 mb-2">
                      <i className="bi bi-clock-fill" style={{ color: "#764ba2", fontSize: "13px" }}></i>
                      <span style={{ fontSize: "12px", fontWeight: "600", color: "#764ba2", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Schedule & Terminals
                      </span>
                    </div>

                    {/* 4 inputs */}
                    <div className="row g-2 mb-2">
                      {[
                        { name: "depTime", placeholder: "Dep Time (HH:MM)", value: flightDetail?.depTime, onChange: handleTimeChange, maxLength: 5, icon: "bi-arrow-up-circle" },
                        { name: "arrTime", placeholder: "Arr Time (HH:MM)", value: flightDetail?.arrTime, onChange: handleTimeChange, maxLength: 5, icon: "bi-arrow-down-circle" },
                        { name: "depTerminal", placeholder: "Dep Terminal", value: flightDetail?.depTerminal, onChange: handleChange, maxLength: undefined, icon: "bi-door-open" },
                        { name: "arrTerminal", placeholder: "Arr Terminal", value: flightDetail?.arrTerminal, onChange: handleChange, maxLength: undefined, icon: "bi-door-closed" },
                      ].map(({ name, placeholder, value, onChange, maxLength, icon }) => (
                        <div className="col-6 col-md-3" key={name}>
                          <div className="input-group input-group-sm">
                            <span className="input-group-text" style={{ background: "#f0e8ff", border: "1.5px solid #d6bcfa", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                              <i className={`bi ${icon}`} style={{ color: "#764ba2", fontSize: "12px" }}></i>
                            </span>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              placeholder={placeholder}
                              name={name}
                              value={value || ""}
                              onChange={onChange}
                              maxLength={maxLength}
                              style={{ border: "1.5px solid #d6bcfa", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "white", fontSize: "13px" }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Save button — full width on mobile, right-aligned on desktop */}
                    <div className="d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-sm text-white fw-semibold d-flex align-items-center justify-content-center gap-2 w-100 w-md-auto"
                        style={{
                          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                          borderRadius: "10px", border: "none",
                          boxShadow: "0 3px 10px rgba(102,126,234,0.4)",
                          height: "38px", maxWidth: "200px"
                        }}
                      >
                        <i className="bi bi-floppy-fill"></i> Save Flight
                      </button>
                    </div>

                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AddFlight;